<div class="flex flex-row flex-wrap justify-between animal-overview-filters">
  <div class="flex xs:col-12 md:col flex-wrap md:flex-nowrap items-end md:flex-none p-1 gap-1">
    @for (filter of typeFilters; track filter) {
      <div class="flex justify-center items-end">

          <div class="flex flex-col size-20 items-center justify-center m-1 p-4 rounded-lg cursor-pointer"
                [ngClass]="selectedFilters.includes(filter.id) ? 'inset-shadow-sm inset-shadow-[#a5a5a5]' : ''"
                role="button"
                tabindex="0"
                aria-pressed="{{ selectedFilters.includes(filter.id) }}"
               (click)="selectedFilters.includes(filter.id) ? onFilterDeselect(filter) : onFilterSelect(filter)">
            <div class="min-h-[30px] flex items-center justify-center">
              <p-image class="block mx-1" [src]="filter.imgSrc" width="37"
                       [imageStyle]="{ 'max-height': '30px' }"></p-image>
            </div>
            <p class="mt-2 font-semibold text-color-secondary">{{ filter.title }}</p>
          </div>


      </div>
    }
  </div>
  <div class="col flex flex-none justify-end">
    <div class="col flex-none flex items-center">
      <p-selectButton #layoutOptions></p-selectButton>
    </div>
  </div>
</div>
